import React from 'react'

function Copyright() {
    return (
        <section id="copyright">
			<div className="container">
				<div className="copyright-detail">
					<p>© 2021 <a href="#main-part" target="_blank">Jessica Kuijer</a> - Tous droits réservés.</p>
				</div>
			</div>
		</section>
    )
}

export default Copyright
